/* Comportamento do CTA do card: contador de quantidade, selo sobre a foto e adicionar sem
   recarregar. Um arquivo so pelo mesmo motivo do CSS: o snippet repete por card. */
(function () {
    /* A trava de reentrada tem nome novo de proposito. Cards servidos do cache ainda trazem
       o <script> da versao anterior, que roda antes deste por ser inline, e marcava
       __safe1ccAddReady: com o nome antigo este arquivo saia na primeira linha e nada do que
       vem abaixo era registrado, nem a limpeza das folhas velhas nem o selo sobre a foto. */
    if (window.__safe1ccReady2) return;
    window.__safe1ccReady2 = true;

    // leva cada selo para o canto da foto. O bloco nasce dentro de .productitem--info, que e
    // position relative, entao o selo precisa trocar de pai para se ancorar no card inteiro.
    /* Ate 26/08/2026 este CSS morava dentro do snippet, entao cada card levava a propria
       copia. Cards que chegam do cache (o bloco de vistos recentemente e a grade por AJAX)
       ainda trazem a folha antiga, e por entrarem depois na pagina ela vencia a cascata e
       impunha o layout velho a todos os outros cards. Enquanto esse cache nao expira, os
       resIduos sao removidos aqui: o que vale e o asset carregado no cabecalho. */
    function limpaEstiloAntigo(raiz) {
      (raiz || document).querySelectorAll('.productitem--info style, .productitem style').forEach(function (folha) {
        if (folha.textContent.indexOf('.safe1cc__form') !== -1) folha.remove();
      });
    }
    limpaEstiloAntigo();
    /* o bloco de vistos recentemente monta os cards em etapas, e a folha antiga entra depois
       da primeira leva de mutacoes, entao vale repassar quando a pagina termina de carregar */
    window.addEventListener('load', function () {
      limpaEstiloAntigo();
      posicionaSelos();
      setTimeout(function () { limpaEstiloAntigo(); posicionaSelos(); }, 700);
    });

    function posicionaSelos(raiz) {
      (raiz || document).querySelectorAll('[data-safe1cc-selo]').forEach(function (selo) {
        var card = selo.closest('.productitem');
        if (!card || selo.parentNode === card) return;
        card.insertBefore(selo, card.firstChild);
        selo.classList.add('safe1cc__selo--flutua');
      });
    }
    posicionaSelos();

    // grade que carrega por AJAX (filtro, paginacao, busca instantanea) traz cards novos
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () { limpaEstiloAntigo(); posicionaSelos(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    }

    // contador de quantidade. Sem JavaScript os dois botoes nao fazem nada e o campo do meio
    // segue digitavel, que e o comportamento de sempre.
    document.addEventListener('click', function (event) {
      var passo = event.target.closest('[data-safe1cc-mais], [data-safe1cc-menos]');
      if (!passo) return;
      var campo = passo.parentNode.querySelector('.safe1cc__qtd');
      if (!campo) return;
      var atual = parseInt(campo.value, 10) || 1;
      var novo = passo.hasAttribute('data-safe1cc-mais') ? atual + 1 : atual - 1;
      campo.value = novo < 1 ? 1 : novo;
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches('[data-safe1cc-form]')) return;

      // sem fetch no navegador, deixa o post nativo acontecer
      if (typeof window.fetch !== 'function') return;

      event.preventDefault();

      var botao = form.querySelector('[data-safe1cc-add]');
      var idEl = form.querySelector('[name="id"]');
      var qtdEl = form.querySelector('[name="quantity"]');
      var id = idEl ? Number(idEl.value) : 0;
      var qtd = qtdEl ? Math.max(1, parseInt(qtdEl.value, 10) || 1) : 1;
      if (!id) return;

      var rotulo = botao ? botao.querySelector('[data-safe1cc-add-txt]') || botao : null;
      var textoOriginal = rotulo ? rotulo.textContent : '';
      if (botao) { botao.disabled = true; }
      if (rotulo) { rotulo.textContent = 'Adicionando'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: id, quantity: qtd }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'erro');
          if (rotulo) { rotulo.textContent = 'Adicionado'; }
          if (botao) { botao.classList.add('is-ok'); }
          // atualiza o contador do tema sem recarregar a pagina
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .catch(function () {
          if (rotulo) rotulo.textContent = 'Tente de novo';
        })
        .then(function () {
          setTimeout(function () {
            if (botao) {
              botao.disabled = false;
              botao.classList.remove('is-ok');
            }
            if (rotulo) { rotulo.textContent = textoOriginal; }
          }, 2200);
        });
    });
  }());
